import type { CapiProductPage } from 'types/capi/pdp';

import Breadcrumbs from '~/components/BreadCrumbs';
import useNavigationLinkInteraction from '~/hooks/useNavigationLinkInteraction';
import usePageData from '~/hooks/usePageData';

const PdpBreadcrumbs = () => {
  const product = usePageData<CapiProductPage>();
  const fireNavigationLink = useNavigationLinkInteraction('breadcrumb');

  return (
    <Breadcrumbs
      breadcrumbs={product.breadcrumbs}
      onCrumbClick={(crumb, position) =>
        fireNavigationLink(crumb.path, position)
      }
    />
  );
};

export default PdpBreadcrumbs;
